import app from '../app.first';
import $ from 'jquery';

app.RecruiterAccount = class extends app.Component {
	constructor($this) {
        super($this);
        $(() => this.onDocumentReady($this));
        $(() => this.addressBehavior($this));

	}

    onDocumentReady($this) {
        $('.add-mobile').click(function() {
            $('.second-mobile').removeClass('hide');
            $(this).remove();
        });
    }

    addressBehavior($this) {
        $('#province').select2({
            minimumResultsForSearch: -1,
            ajax: {
                url: '/ajax/province-for-country',
                dataType: 'json',
                data: function (params) {
                    let query = {
                        countryId: $('#country_id').val(),
                    }

                    return query;
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                },
            }
        });
        
        $('#country_id').select2().on('change', function() {
            $('#province_id').select2({
                minimumResultsForSearch: -1,
                ajax: {
                    url: '/ajax/province-for-country',
                    dataType: 'json',
                    data: function (params) {
                        console.log('test');
                        let query = {
                            countryId: $('#country_id').val(),
                        }
    
                        return query;
                    },
                    processResults: function (data) {
                        console.log(data);
                        return {
                            results: data
                        };
                    },
                }
            });
        }).trigger('change');
    }
}